import React from "react";
import { Image } from "react-bootstrap";
import { connect } from "react-redux";
import i18n from "I18n";

import InputFieldControl from "components/base/InputFieldControl";
import LanguageTabs from "components/base/LanguageTab";
import CouponDropdownWithButtonAndPrompt from "components/earning/CouponDropdownWithButtonAndPrompt";
import { CustomTitleLabel } from "components/earning/CustomBaseComponments";
import { COUPON_TYPES, LanguageConfig } from "config/CustomEnums";
import { PermissionCodes } from "config/PermissionCodes";
import DeleteIcon from 'assets/images/deleteIcon.png';

import './CouponSetTimeSlot.scss'
import { useFormContext } from "react-hook-form";
import { VALID_PERIOD_TYPE } from "models/CreateCouponModel";
import { formatDate } from "utils/TimeFormatUtil";

const mapPropsToState = (state) => ({
  languages: state.language.allList,
});
const CouponSetTimeSlot = ({
  areaTitle,
  fieldNamePrefix,
  languages,
  hideDeleteButton = false,
  removeAction = () => { },
}) => {
  const couponSetFieldName = `${fieldNamePrefix}.couponSet`
  const translationsFieldName = `${fieldNamePrefix}.translations`

  const { watch, setValue } = useFormContext();
  const selectedCouponSet = watch(couponSetFieldName)

  const timeSlotFormat = {
    [LanguageConfig.english]: "hh:mm:ss A, DD MMM yyyy",
    [LanguageConfig.simplifiedChinese]: "yyyy年MM月DD日 A hh:mm",
    [LanguageConfig.traditionalChinese]: "yyyy年MM月DD日 A hh:mm",
  }
  const displayAllTime = {
    [LanguageConfig.english]: "Always",
    [LanguageConfig.simplifiedChinese]: "永久有效",
    [LanguageConfig.traditionalChinese]: "永久有效",
  }

  const getCouponSetDisplayTimePeriod = ({
    language,
    periodType,
    startTime,
    endTime,
  }) => {
    if (periodType === VALID_PERIOD_TYPE.ALL_TIME) {
      return displayAllTime?.[language] || displayAllTime[LanguageConfig.english]
    } else if (periodType === VALID_PERIOD_TYPE.ABSOLUTE) {
      let formatDateTime = `${
        formatDate(startTime, timeSlotFormat?.[language] || timeSlotFormat?.[LanguageConfig.english])
      }~${formatDate(endTime, timeSlotFormat?.[language] || timeSlotFormat?.[LanguageConfig.english])}`
      if ([LanguageConfig.simplifiedChinese, LanguageConfig.traditionalChinese].includes(language)) {
        formatDateTime = formatDateTime.replace("AM", "上午").replace("PM", "下午" )
      }
      return formatDateTime
    }
    return ""
  }

  const setDefaultTimeSlot = (newCouponSet) => {
    languages?.length > 0 && languages.forEach((language) => {
      setValue(
        `${translationsFieldName}.${language.code}.timeSlot`,
        getCouponSetDisplayTimePeriod({
          language: language.code,
          periodType: newCouponSet?.validPeriodType,
          startTime: newCouponSet?.absoluteEffectiveDate,
          endTime: newCouponSet?.absoluteExpiryDate,
        }),
        { shouldDirty: true }
      )
    })
  }

  const getDisplayStockInfo = () => {
    return selectedCouponSet
      ? `${selectedCouponSet?.totalNumberOfAcquiredCoupons || 0}/${selectedCouponSet?.totalNumberOfUsedCoupons || 0}/${selectedCouponSet?.totalNumberOfGeneratedCoupons || 0}`
      : "-"
  }

  const getLanguageTabs = (
    language
  ) => {
    const couponValidTimePeriod = getCouponSetDisplayTimePeriod({
      language,
      periodType: selectedCouponSet?.validPeriodType,
      startTime: selectedCouponSet?.absoluteEffectiveDate,
      endTime: selectedCouponSet?.absoluteExpiryDate,
    })

    return (
      <>
        {language === LanguageConfig.english &&
          <CouponDropdownWithButtonAndPrompt
            title={"Select coupon set (ticket type)"}
            bottomTips={`Acquired/Used/Total Stock: ${getDisplayStockInfo()}`}
            dropDownSearchBarPlaceholder={"Search by coupon set ID and name"}
            valueFieldName={couponSetFieldName}
            hasAddButton={true}
            addButtonInfo={{
              requires: PermissionCodes.changeCouponTemplate,
            }}
            promptConfig={{
              title: 'Go to create a Coupon Set?',
              message: `You will leave the campaign creation process. After you create a coupon set, you can come back to create a ticket campaign.`,
              button: 'Go to Create Coupon Set',
              refreshButton: 'Done and refresh',
              action: () => { window.open(`/coupons/create?type=${COUPON_TYPES.TICKET}`, "_blank") }
            }}
            defaultFilter={{
              type: [COUPON_TYPES.TICKET]
            }}
            noTopSpace={false}
            customOnChange={(couponSet) => {
              setDefaultTimeSlot(couponSet)
            }}
          />
        }
        <InputFieldControl
          name={`${translationsFieldName}.${language}.timeSlot`}
          title={i18n.t("timeSlot", { locale: language })}
          useDefaultFieldName={true}
          useDefaultValue={false}
          tips={i18n.t("timeSlotTips", { locale: language, timePeriod: couponValidTimePeriod || "-" })}
        />
      </>
    )
  }
  return (<>
    <div className="create-section-label-bottom-space time-slot-container">
      <div className={hideDeleteButton ? "" : "flex-row-space-between"}>
        <CustomTitleLabel title={areaTitle} />
        {!hideDeleteButton &&
          <button
            className="delete-condition-group-button"
            type="button"
            onClick={() => {
              removeAction()
            }}
          >
            <Image src={DeleteIcon} className="content-delete-button" />
          </button>
        }
      </div>
      <LanguageTabs
        // fieldsError={fieldsError}
        // errorLanguage={errorLanguage}
        containers={languages?.map((language) => ({
          key: language.code,
          title: language.sourceName,
          container: getLanguageTabs(language.code),
        }))}
        languageTabsStyle={"time-slot-languages-tabs"}
      />
    </div>
  </>)
}
export default connect(mapPropsToState)(CouponSetTimeSlot);
